import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { Filter } from '@brafton/angular-framework-library';
import { UserProfile } from '@brafton/common-framework-library';
import { ProfileStub } from '@brafton/core-api-client';

@Component({
  selector: 'shared-filter-panel-owners',
  templateUrl: './filter-panel-owners.component.html',
  styleUrls: ['./filter-panel-owners.component.scss'],
  host: { class: 'shared-filter-panel-owners' },
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class SharedFilterPanelOwnersComponent implements OnInit {
  @Input() owners: Filter[] = [];
  @Output() ownersChange: EventEmitter<Filter[]> = new EventEmitter<Filter[]>();
  @Output() close: EventEmitter<any> = new EventEmitter();

  constructor() {}

  ngOnInit() {}

  add(userDef: ProfileStub) {
    if (!this.owners.find((sp) => sp.value === userDef.id.toString())) {
      this.owners.push({ value: userDef.id, displayName: userDef.name, type: 'user' } as Filter);
    }
    this.ownersChange.emit(this.owners);
  }

  remove(userDef: Filter) {
    const index = this.owners.findIndex((sp) => sp.value === userDef.value);
    if (index > -1) {
      this.owners.splice(index, 1);
    }
    this.ownersChange.emit(this.owners);
  }

  clear() {
    this.owners = [];
    this.ownersChange.emit(this.owners);
  }
}
